import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { getRouterLinkUrlById } from '@lsq-frontend/common-ui';
import { DashboardExperience } from '../../../constants/experience.constants';
import { atlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { AppSettings } from '@lsq-frontend/fasttrack-shared/environment';

@Component({
    selector: 'admin-user-management',
    template: `
        <page-header
            titleText="Admin User Management"
            backButtonText="back to admin overview"
            (handleBackButtonClick)="navigateToAdminOverviewPage()"
        >
        </page-header>

        <div class="container-fluid page-container">
            <card [headerTitle]="'User Management'">
                <div card-body>
                    <users
                        [clientDashboardExperiences]="clientDashboardExperiences"
                        [companyKey]="companyKey"
                        [isLsqAdminCompany]="true"
                    >
                    </users>
                </div>
            </card>
        </div>
    `
})
export class AdminUserManagementComponent {
    public clientDashboardExperiences = [DashboardExperience.Factoring];
    public companyKey = this._settings.lsqAdminCompanyKey;

    constructor(private _router: Router, @Inject(SETTINGS) private _settings: AppSettings) {}

    public navigateToAdminOverviewPage(): void {
        this._router.navigateByUrl(getRouterLinkUrlById(atlas, 'ADMIN_OVERVIEW'));
    }
}
